module.exports = __webpack_public_path__ + "static/media/46_B.cf30b456.png";